import Modal from "react-bootstrap/Modal";
import searchs from "../asset/images/search-normal.svg";
import { countrycodelist } from "../constants/countryList";
import { useState } from "react";
import "../style/main.css";
import "../style/rightside.css";

function BankModal(props) {
    const [search, setsearch] = useState("");
    const [searchbank, setsearchbank] = useState("");

    const [bankshow, setbankshow] = useState(false);
    const [selectedcountry, setselectedcountry] = useState([]);

    const filtercontant = countrycodelist.filter((countrycodelists) =>
        countrycodelists.title?.match(search)
    );
    
    const filterBank = props.banks?.banks?.filter((bank) =>
        bank.bankName?.toLowerCase()?.includes(searchbank.toLowerCase())
    );

    props.banks?.banks?.sort((a, b) => a.name?.localeCompare(b.name, "es", { sensitivity: "base" }));

    let data = filterBank?.reduce((r, e) => {
        let alphabet = e.bankName[0];

        if (!r[alphabet])
            r[alphabet] = {
                alphabet,
                record: [],
            };

        r[alphabet].record.push(e);
        return r;
    }, {});
    let result = data ? Object.values(data) : [];

    const getselectedcountry = (country) => {
        setselectedcountry(country);
        setbankshow(!bankshow);
        var datashow = props.show;
        props.setshow(!datashow);
    };
    const closeModal = () => {
        var datashow = props.show;
        props.setshow(!datashow);
    };
    const closeModal2 = () => {
        props.setshow(false);
        setbankshow(false);
    };
    /*
    const mybank = mybank => {
        var dataList = props.selectedbank
      if(props.selectedbank.length > 0){
        dataList = []
        props.setselectedbank([
            // eslint-disable-next-line
            ... props.selectedbank,
            mybank
        ])
        setbankshow(false)

    }else{
        props.setselectedbank([
            // eslint-disable-next-line
            ... props.selectedbank,
            mybank
        ])
        setbankshow(false)



    }

      }
    */
    return (
        <>
            <Modal
                show={false}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="border-0"
            >
                <Modal.Body
                    style={{
                        borderRadius: "16px",
                        padding: "0px",
                        border: "none",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "10px",
                        }}
                    >
                        <div
                            className=""
                            style={{
                                borderBottom: "1px solid #E7E9FB",
                                padding: "8px 24px 8px 24px",
                            }}
                        >
                            <span
                                className="material-icons"
                                style={{ color: "#667085" }}
                                onClick={closeModal}
                            >
                                close
                            </span>
                        </div>
                        <div style={{ padding: "8px 24px 8px 24px" }}>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "32px",
                                    marginBottom: "10px",
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "24px",
                                    }}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "8px",
                                        }}
                                    >
                                        <h3
                                            style={{
                                                color: "#101828",
                                                fontSize: "20px",
                                                lineHeight: "24px",
                                                fontWeight: "500",
                                                margin: "0px",
                                            }}
                                        >
                                            Change Bank
                                        </h3>
                                    </div>
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "32px",
                                        }}
                                    >
                                        <div
                                            style={{
                                                background: "#ECEFF3",
                                                padding: "0px 8px 0px 8px",
                                                borderRadius: "8px",
                                                gap: "8px",
                                                display: "flex",
                                            }}
                                        >
                                            <img src={searchs} alt="" />
                                            <input
                                                type="search"
                                                onChange={(e) => setsearch(e.target.value)}
                                                style={{
                                                    width: "100%",
                                                    background: "inherit",
                                                    outline: "none",
                                                    border: "none",
                                                    padding: "0px 8px 0px 8px",
                                                    height: "46px",
                                                }}
                                                placeholder="Search countries"
                                            />
                                        </div>
                                        <div
                                            style={{
                                                background: "#fff",
                                                borderRadius: "8px",
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: "16px",
                                                padding: "8px",
                                                maxHeight: "1260px",
                                                height: "100%",
                                                overflow: "auto",
                                            }}
                                        >
                                            {" "}
                                            {filtercontant.map((country, index) => (
                                                <div
                                                    key={index}
                                                    style={{
                                                        display: "flex",
                                                        gap: "8px",
                                                        alignItems: "center",
                                                        cursor: "pointer",
                                                    }}
                                                    onClick={() => {
                                                        getselectedcountry(country);
                                                    }}
                                                >
                                                    <img
                                                        src={country.image}
                                                        alt=""
                                                        style={{ borderRadius: "100% " }}
                                                    />
                                                    <span
                                                        style={{
                                                            color: "#344054",
                                                            fontWeight: "500",
                                                            lineHeight: "19.6px",
                                                            fontSize: "14px",
                                                        }}
                                                    >
                                                        {" "}
                                                        {country.title}{" "}
                                                    </span>
                                                </div>
                                            ))}{" "}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal
                show={props.show}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="border-0 "
            >
                <Modal.Body
                    style={{
                        borderRadius: "16px",
                        padding: "0px",
                        border: "none",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "10px",
                        }}
                    >
                        <div
                            className=""
                            style={{
                                borderBottom: "1px solid #E7E9FB",
                                padding: "8px 24px 8px 24px",
                            }}
                        >
                            <span
                                className="material-icons"
                                style={{
                                    color: "#667085",
                                    cursor: "pointer",
                                }}
                                onClick={closeModal2}
                            >
                                close
                            </span>
                        </div>
                        <div style={{ padding: "8px 24px 8px 24px" }}>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "32px",
                                    marginBottom: "10px",
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "24px",
                                    }}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "8px",
                                        }}
                                    >
                                        <h3
                                            style={{
                                                color: "#101828",
                                                fontSize: "20px",
                                                lineHeight: "24px",
                                                fontWeight: "500",
                                                margin: "0px",
                                            }}
                                        >
                                            Change Bank
                                        </h3>
                                    </div>

                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "16px",
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: "8px",
                                            }}
                                        >
                                            {props.bank === false && (
                                                <label
                                                    htmlFor="Bank's country"
                                                    style={{
                                                        color: "#344054",
                                                        fontSize: "14px",
                                                        lineHeight: "19.6px",
                                                        fontWeight: "600",
                                                    }}
                                                >
                                                    Bank’s country
                                                </label>
                                            )}
                                            {props.bank === false && (
                                                <div
                                                    style={{
                                                        background: "#fff",
                                                        padding: "0px 8px 0px 8px",
                                                        borderRadius: "8px",
                                                        gap: "8px",
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            gap: "8px",
                                                            alignItems: "center",
                                                            height: "40px",
                                                        }}
                                                    >
                                                        <img
                                                            src={selectedcountry.image}
                                                            alt=""
                                                            style={{ borderRadius: "100% " }}
                                                        />
                                                        <span
                                                            style={{
                                                                color: "#101828",
                                                                fontSize: "16px",
                                                                fontWeight: "600",
                                                                lineHeight: "24px",
                                                                letterSpacing: "2%",
                                                            }}
                                                        >
                                                            {" "}
                                                            {selectedcountry.title}{" "}
                                                        </span>
                                                    </div>
                                                    <div className="material-icons">
                                                        keyboard_arrow_down
                                                    </div>
                                                </div>
                                            )}

                                            <div
                                                style={{
                                                    background: "#ECEFF3",
                                                    padding: "0px 8px 0px 8px",
                                                    borderRadius: "8px",
                                                    gap: "8px",
                                                    display: "flex",
                                                }}
                                            >
                                                <img src={searchs} alt="" />
                                                <input
                                                    type="search"
                                                    onChange={(e) => setsearchbank(e.target.value)}
                                                    style={{
                                                        width: "100%",
                                                        background: "inherit",
                                                        outline: "none",
                                                        height: "48px",
                                                        border: "none",
                                                        padding: "0px 8px 0px 8px",
                                                    }}
                                                    value={searchbank}
                                                    placeholder="Search bank"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "32px",
                                            height: "calc(100vh - 300px)",
                                            overflow: "auto",
                                        }}
                                    >
                                        {result.map((contact, index) => (
                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    gap: "8",
                                                }}
                                                key={index}
                                            >
                                                <span
                                                    style={{
                                                        color: "#667085",
                                                        fontSize: "12px",
                                                        lineHeight: "16.2px",
                                                        fontWeight: "500",
                                                    }}
                                                >
                                                    {" "}
                                                    {contact.alphabet}
                                                </span>
                                                {contact.record.map((records, index) => (
                                                    <div
                                                        style={{
                                                            background: "#fff",
                                                            display: "flex",
                                                            gap: "16px",
                                                            justifyContent: "space-between",
                                                            padding: "8px",
                                                            alignItems: "center",
                                                        }}
                                                        onClick={() => {
                                                            props.setselectedbank(records);
                                                            props.setshow(false);
                                                        }}
                                                        className="modaltopdomwnradius"
                                                        key={index}
                                                    >
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                gap: "8px",
                                                                alignItems: "center",
                                                            }}
                                                        >
                                                            <img src={search} alt="" />
                                                            <div
                                                                style={{
                                                                    color: "#101828",
                                                                    fontSize: "16px",
                                                                    fontWeight: "600",
                                                                    lineHeight: "24px",
                                                                    letterSpacing: "2%",
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    cursor: "pointer",
                                                                }}
                                                            >
                                                                <span
                                                                    style={{
                                                                        color: "#101828",
                                                                        lineHeight: "24px",
                                                                        letterSpacing: "2%",
                                                                        fontSize: "16px",
                                                                        fontWeight: "500",
                                                                    }}
                                                                >
                                                                    {" "}
                                                                    {records.bankName}{" "}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}{" "}
                                            </div>
                                        ))}{" "}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default BankModal;
